import type { ModulesOpts } from '@/hooks/dictionary';

export const module: ModulesOpts = [
  {
    name: '设计模块',
    codes: [...new Set(
      [
        'pims_category',
        'plm_standard_size',
        'plm_cancel_reason',
        'plm_purchase_ylbw',
        'plm_demand_type',
        'purchase_request_reason',
        'plm_style_source',
        'plm_sales_group',
        'plm_cloth_unit',
        'plm_tag_material',
        'plm_needle_and_shuttle_weaving_method',
        'plm_material_type',
        'plm_pattern_category',
        'plm_quality_requirement',
        'plm_reference_season',
        'plm_elastic_requirement',
        'plm_reference_thickness',
        'plm_reference_weight_unit',
        'plm_element', 'plm_price_unit',
        'plm_material_quality',
        'plm_dimension_requirement_unit',
        'plm_umber_requirement_unit',
        'plm_sample_special_craft',
        'pims_fabric_serial_number',
        'pims_accessory_serial_number',
        'plm_cancel_purchase_reason',
        'plm_plate_type',
        'plm_design_sample_quality_level',
        'pims_regionbelong',
      ],
    )],
  },
];
